import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const circle = (t: typeof theme) => ({
  display: 'block',
  content: '""',
  background: t.white,
  width: '.375rem',
  height: '.375rem',
  position: 'absolute',
  borderRadius: '50%',
})

const useStyles = createUseStyles((t: typeof theme) => ({
  contextualMenu: {
    position: 'relative',
    marginBottom: '-0.375rem',
  },

  opener: {
    display: 'block',
    width: '1.8rem',
    height: '1.8rem',
    cursor: 'pointer',
    userSelect: 'none',
    padding: 0,
    border: 0,
    borderRadius: 0,
    font: 'inherit',
    fontSize: 'inherit',
    backgroundColor: 'transparent',
    color: 'inherit',
    opacity: 0.8,
    transition: 'opacity 300ms ease',

    '&:focus, &:active:focus': {
      outline: '0',
    },

    '&:hover': {
      opacity: 1,
    },
  },

  dots: {
    extend: () => circle(t),
    top: '.7125rem',
    left: '0.25rem',

    '&:before': {
      extend: () => circle(t),
      top: 0,
      left: '.5rem',
    },

    '&:after': {
      extend: () => circle(t),
      top: 0,
      left: '1rem',
    },
  },

  menu: {
    position: 'absolute',
    zIndex: t.zIndexUserMenu,
    top: '2.2rem',
    right: '-.8rem',
    border: `.0631rem solid ${t.gray03}`,
    backgroundColor: t.white,
    boxShadow: `0 .19rem 1.25rem rgba(0, 0, 0, .05)`,
    animation: '$show 200ms ease',

    '& ul': {
      padding: 0,
      margin: 0,
      listStyle: 'none',
      width: '10.1rem',
    },

    '&:before': {
      position: 'absolute',
      top: '-.375rem',
      right: '1.3rem',
      content: '""',
      display: 'block',
      width: '.625rem',
      height: '.625rem',
      borderRight: `.0631rem solid ${t.gray03}`,
      borderTop: `.0631rem solid ${t.gray03}`,
      backgroundColor: t.white,
      transform: 'rotate(-45deg)',
    },

    '& li': {
      borderBottom: `.0631rem solid ${t.gray03}`,
    },

    '& li:last-child': {
      borderBottom: 0,
    },
  },

  '@keyframes show': {
    '0%': {
      display: 'none',
      opacity: 0,
    },
    '1%': {
      display: 'block',
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  button: {
    padding: '.4rem .5rem',
    textAlign: 'left',
  },

  buttonDestroy: {
    color: t.buttonDestroyBgColor,
  },

  buttonContent: {
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    display: 'block',
    width: '1.25rem',
    fontSize: '.8rem',
  },

  label: {
    flex: 1,
  },
}))

export default useStyles
